<template>
	<div class="msg_box">
		<div></div>
		<div class="arrow_box clearfloat">
			<span class="arrow_ywz">您的位置：</span>
			<div class="arrow">
				<span class="to" @click="xin.goUrl('/index')">首页</span>
				<span class="el-icon-arrow-right"></span>
				<span class="to" @click="xin.goUrl('/integral')">积分兑换</span>
				<span class="el-icon-arrow-right"></span>
				<span class="topc">确认订单</span>
			</div>
		</div>
		<div class="succ">
			<div class="succ_title" @click="xin.goUrl('/integral')">撸起袖子继续买，更多积分，更好礼品等你拿!</div>
			<div v-if="order_id" class="laing_btn" @click="xin.goUrl('/integral/orders/'+order_id)">查看订单</div>
			<div v-else class="laing_btn" @click="xin.goUrl('/personalCenter/miOrder')">查看订单</div>
			<div class="laing red" @click="xin.goUrl('/activity')">查看更多促销活动</div>
		</div>
	</div>
</template>

<script>
	export default{
		data(){
			return{
				order_id:'',
			}
		},
		created(){
			this.order_id = this.$route.query.order_id;
		},
		methods:{
		}
	}
</script>

<style lang="scss" scoped="scoped">
	.succ{
		width: 400px;
		margin:100px auto;
		text-align: center;
		& > div{
			margin: 30px 0;
		}
		.red{
			color: #B03130;
		}
		.succ_title{
			cursor: pointer;
			font-size: 24px;
			text-align: center;
			color: #333333;
			line-height: 36px;
		}
		.laing{
			margin: 30px ;
			font-size: 30px;
		}
		.laing_btn{
			
			display: inline-block;
			width: 120px;
			height: 40px;
			line-height: 40px;
		}
	}
	
</style>
